import { render, staticRenderFns } from "./TemplateMessageButtons.vue?vue&type=template&id=d9d77e6c&scoped=true&"
import script from "./TemplateMessageButtons.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageButtons.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMessageButtons.vue?vue&type=style&index=0&id=d9d77e6c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d77e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VBtnToggle,VFlex,VIcon,VLayout,VTextField})
